"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDatasetRequestToJSON = exports.UpdateDatasetRequestFromJSONTyped = exports.UpdateDatasetRequestFromJSON = exports.instanceOfUpdateDatasetRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateDatasetRequest interface.
 */
function instanceOfUpdateDatasetRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateDatasetRequest = instanceOfUpdateDatasetRequest;
function UpdateDatasetRequestFromJSON(json) {
    return UpdateDatasetRequestFromJSONTyped(json, false);
}
exports.UpdateDatasetRequestFromJSON = UpdateDatasetRequestFromJSON;
function UpdateDatasetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.UpdateDatasetRequestFromJSONTyped = UpdateDatasetRequestFromJSONTyped;
function UpdateDatasetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}
exports.UpdateDatasetRequestToJSON = UpdateDatasetRequestToJSON;
